module.exports = __webpack_public_path__ + "img/car_00039.04574e09.jpg";